import { createAction, createSelector, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';
import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';
import { subscriptionHistory } from 'services';

const adapter = createEntityAdapter({});

const slice = createSlice({
  name: 'subscriptionHistory',
  initialState: adapter.getInitialState({
    busy: false,
  }),
  reducers: {
    setAll: adapter.setAll,
    addOne: adapter.addOne,
    addMany: adapter.addMany,
    updateOne: adapter.updateOne,
    updateMany: adapter.updateMany,
    upsertOne: adapter.upsertOne,
    upsertMany: adapter.upsertMany,
    removeOne: adapter.removeOne,
    removeMany: adapter.removeMany,
    removeAll: adapter.removeAll,
    setBusy(state, action) {
      let busy = action.payload;
      if (busy === false) {
        state.busy = false;
      } else {
        state.busy = true;
      }
    },
  },
});

const fetchSubscriptionsHistory = (filters, params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    dispatch(slice.actions.removeAll());
    const resData = await subscriptionHistory.fetchSubscriptionsHistory(filters, params);
    dispatch(slice.actions.setAll(resData));
  } catch (err) {
    dispatch(slice.actions.setAll({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const actions = {
  ...slice.actions,
  fetchSubscriptionsHistory,
};

const selectors = {
  ...adapter.getSelectors((state) => state.subscriptionHistory),
};

export { actions, selectors };

export default slice.reducer;
